<template>
	<div class="use-wrap">
		<div class="input-head-text">
			<p>{{ tt('사용량') }}</p>
			<p>
				<span class="volume-text">{{ tt(`잔여 용량`) }}</span> :
				<span class="current-volume">{{ `${volume}${volumeUnit}` }}</span>
			</p>
		</div>
		<div class="input-container">
			<div class="input-wrap">
				<input
					class="input-use"
					:class="{ error: isShowVolumeError && isInputVolumeOver(volume) }"
					:value="inputValue"
					:placeholder="tt(`사용량을 입력해주세요`)"
					@input="handleChange"
				/>
				<span class="input-unit">{{ volumeUnit }}</span>
			</div>
			<button class="button-gray" @click="useAll">
				{{ tt('잔량 모두 입력') }}
			</button>
		</div>
		<p class="error-msg" v-if="isShowVolumeError && isInputVolumeOver(volume)">
			<img src="@/views/inventoryGen2/components/svg/icon-error.svg" />
			{{ isInputVolumeEmpty ? tt(`사용량을 입력해주세요.`) : tt(`잔여 용량을 초과하였습니다.`) }}
		</p>
	</div>
</template>
<script>
import MixinItem from '@/mixins/inventory/MixinItem'
import { mapGetters, mapMutations } from 'vuex'
import Decimal from 'decimal.js'
export default {
	name: 'ChemicalInput',
	mixins: [MixinItem],
	components: {},
	props: {
		volume: {
			type: [Number, String],
			default: null,
		},
		volumeUnit: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			inputValue: '',
		}
	},
	computed: {
		...mapGetters('modal/inputUse', ['useVolume', 'isInputVolumeEmpty', 'isShowVolumeError', 'isInputVolumeOver']),
	},
	watch: {
		inputValue(value) {
			if (value < this.volume) {
				this.setIsShowVolumeError(false)
			}
		},
	},
	created() {},
	mounted() {},
	methods: {
		...mapMutations('modal/inputUse', ['setUseVolume', 'setIsShowVolumeError']),
		init() {
			this.inputValue = null
			this.$emit('input', this.inputValue)
			this.setIsShowVolumeError(false)
		},
		useAll() {
			this.inputValue = this.volume
			this.$emit('input', this.inputValue)
		},
		handleChange(e) {
			// 유리수 검증 regex
			const regex = /^\d*[.]{0,1}\d{0,}$/
			const isNumber = e.target.value.match(regex)?.length > 0
			if (isNumber) {
				this.inputValue = e.target.value
			} else {
				const length = e.target.value.length
				e.target.value = e.target.value.slice(0, length - 1)
				this.inputValue = e.target.value
			}
			this.$emit('input', this.inputValue ? Decimal(this.inputValue).toNumber() : '')
		},
	},
}
</script>

<style lang="scss" scoped>
input {
	width: 100%;
	font-size: 14px;
	padding: 0px;
	border: 1px solid #cccccc;
	border-radius: 5px;
	padding: 5px 60px 5px 10px;
	&.error {
		border: 1px solid #ff3b31 !important;
	}
}

p {
	font-size: 14px;
	font-weight: 400;
}

.input-container {
	display: flex;
	gap: 10px;
	height: 30px;
	.input-wrap {
		display: flex;
		width: 100%;
		position: relative;
		.input-unit {
			width: 60px;
			position: absolute;
			top: 6px;
			right: 0px;
			font-size: 14px;
			text-align: right;
			padding-right: 10px;
		}
	}
}

.use-wrap {
	.input-head-text {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
		& > p {
			font-size: 12px;
			.volume-text {
				color: $PLACEHOLDER;
			}
			.current-volume {
				color: $BLUE;
			}
		}
	}
	.input-use {
		&:focus-within {
			border: 1px solid $SECONDARY_1;
		}
	}
	.require {
		color: $RED;
	}
}

.error-msg {
	display: flex;
	align-items: center;
	color: $RED;
	font-size: 12px;
	font-weight: 400;
	img {
		margin-right: 6px;
	}
}
</style>
